import React from 'react'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { UserProfileAnchor } from './common/UserProfileAnchor/UserProfileAnchor'
import { UserProfileMenu } from './common/UserProfileMenu/UserProfileMenu'

import { useUserProfile } from './hooks'

export const UserProfile = () => {
  const { state, handlers } = useUserProfile()

  const { accounts, activeAccount, activeLanguage, languages, user } = state

  const {
    handleClickAdmin,
    handleLogOut,
    handleSwitchAccount,
    handleSwitchLanguage,
  } = handlers

  return (
    <Dropdown hasArrow>
      <UserProfileAnchor {...{ user }} />
      <UserProfileMenu
        onClickAdmin={handleClickAdmin}
        onLogOut={handleLogOut}
        onSwitchAccount={handleSwitchAccount}
        onSwitchLanguage={handleSwitchLanguage}
        {...{ accounts, activeAccount, activeLanguage, languages }}
      />
    </Dropdown>
  )
}
